import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { Box, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import type { RollMaterial } from "../models/RollMaterial";
import { activeColumnDef } from "@/controls/ag-grid/components/ActiveColumn";

interface UseTableDataProps {
	onDelete: (material: RollMaterial) => void;
}

export const useTableData = ({ onDelete }: UseTableDataProps) => {
	const columnDefs: ColDef<RollMaterial>[] = [
		{
			field: "Name",
			headerName: "Name",
			flex: 3,
			sortable: true,
			filter: true,
		},
		activeColumnDef<RollMaterial>(),
		{
			headerName: "",
			width: 60,
			minWidth: 60,
			maxWidth: 60,
			sortable: false,
			filter: false,
			resizable: false,
			suppressSizeToFit: true,
			cellRenderer: (params: ICellRendererParams<RollMaterial>) => {
				if (!params.data) return null;
				return (
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							height: "100%",
						}}
					>
						<Tooltip title="Delete">
							<IconButton
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									onDelete(params.data as RollMaterial);
								}}
								color="error"
								sx={{ p: 0.25 }}
							>
								<DeleteIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Box>
				);
			},
		},
	];

	return { columnDefs };
};
